import { Head, Link } from "@inertiajs/react"
import { CheckCircle } from "lucide-react"

import { PublicFooter } from "@/components/public-footer"
import { PublicHeader } from "@/components/public-header"
import { Button } from "@/components/ui/button"

interface Props {
  plan_name: string
}

export default function Success({ plan_name }: Props) {
  return (
    <>
      <Head title="Payment Successful | StitchPDF" />

      <div className="bg-background flex min-h-screen flex-col">
        <PublicHeader />

        <main className="container mx-auto flex flex-1 flex-col items-center justify-center px-4 py-16">
          <div className="mx-auto max-w-md text-center">
            <div className="mx-auto mb-6 flex h-16 w-16 items-center justify-center rounded-full bg-green-100 dark:bg-green-900">
              <CheckCircle className="h-8 w-8 text-green-600 dark:text-green-400" />
            </div>

            <h1 className="text-3xl font-bold">Welcome to {plan_name}!</h1>

            <p className="text-muted-foreground mt-4 text-lg">
              Thank you for upgrading. Your account has been updated and you now
              have access to all {plan_name} features.
            </p>

            <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:justify-center">
              <Link href="/dashboard">
                <Button size="lg">Go to Dashboard</Button>
              </Link>
              <Link href="/merge-pdf">
                <Button size="lg" variant="outline">
                  Start Using Tools
                </Button>
              </Link>
            </div>
          </div>
        </main>

        <PublicFooter />
      </div>
    </>
  )
}
